import "core-js/modules/es.array.concat.js";
/* eslint-disable react/prop-types */
import React from 'react';
import { FlywireContainer } from "./style";
import raiseSuccessMessage from "../../../../../util/raiseSuccessMessage";
import { copyToClipboard, useEventTracker } from '@applyboard/ui-utils';
var PAY_VIA_FLYWIRE_EVENT = 'Application Requirements - Clicked Pay via Flywire';
var COPY_FLYWIRE_LINK_EVENT = 'Application Requirements - Clicked Copy Flywire Link';
export var FlywireOptions = function FlywireOptions(_ref) {
  var requirement = _ref.requirement;
  var flywireUrl = "/flywire/".concat(requirement.flywire);
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  function trackFlywireAction(eventName) {
    trackEvent({
      event: eventName
    });
  }
  function onCopyToClipboard() {
    var fullUrl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(flywireUrl);
    copyToClipboard(fullUrl).then(function (isSuccess) {
      if (isSuccess) {
        trackFlywireAction(COPY_FLYWIRE_LINK_EVENT);
        raiseSuccessMessage('Link copied to clipboard');
      }
    });
  }
  return /*#__PURE__*/React.createElement(FlywireContainer, null, /*#__PURE__*/React.createElement("a", {
    href: flywireUrl,
    onClick: function onClick() {
      trackFlywireAction(PAY_VIA_FLYWIRE_EVENT);
    },
    target: "_blank",
    rel: "noreferrer"
  }, "Pay via Flywire"), /*#__PURE__*/React.createElement("span", {
    className: "dot"
  }, "\u25CF"), /*#__PURE__*/React.createElement("button", {
    onClick: onCopyToClipboard
  }, "Copy Flywire link"));
};